import { NavigationEnd, Router } from '@angular/router';
import { Component, OnInit, ViewEncapsulation, HostListener, AfterViewInit, ViewChild, ElementRef, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';

import { FADE_IN_OUT_ANIMATION } from '@shared/animations';
import { LoadingService } from '@shared/modules/loading';
import { AlertService } from '@shared/modules/alert';
import { PageService, ContactUsService, LanguageService, LocationService } from '@shared/services';
import { Page, ContactUsDto, SFLLocation, Language } from '@shared/data';
import { Location } from '@angular/common';

@Component({
  moduleId: 'module.id',
  selector: 'contact-us',
  styles: [require('./contact-us.component.scss')],
  template: require('./contact-us.component.html'),
  animations: [FADE_IN_OUT_ANIMATION]
})
export class ContactUsComponent implements OnInit, AfterViewInit {
  public dto: ContactUsDto;

  public home: Observable<Page>;
  public page: Observable<Page>;
  public locations: Observable<SFLLocation[]>
  public lang: Observable<string>;
  public cfm: Observable<Map<string, any>>;
  public error: Parse.Error;
  public mask: any[];
  public isSending: boolean;

  constructor(
    private pageService: PageService,
    private contactUsService: ContactUsService,
    private languageService: LanguageService,
    private loadingService: LoadingService,
    private alertService: AlertService,
    private locationService: LocationService) {

  }

  public ngOnInit() {
    this.home = this.pageService.home();
    this.page = this.pageService.contactUs();
    this.lang = this.languageService.getCurrentLang();
    this.locations = this.locationService.find().map(o => o.slice(0, 2));
    this.mask = ['(', /[0-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    this.dto = new ContactUsDto();

    this.cfm = this.lang.switchMap(lang => {
      return this.page.map(
        page => {
          let map = new Map<string, string>();

          page.customFields.forEach(o => {
            let v = o.value[lang] || o.value[Language.DEFAULT_LANG];

            map.set(o.key, v);
          });

          return map;
        }
      );
    });
  }

  public ngAfterViewInit() {

  }

  public onAfterChange() {

  }

  public onSend() {
    this.loadingService.continue();
    this.isSending = true;

    this.contactUsService.send(this.dto).then(
      result => {
        this.dto = new ContactUsDto();
        this.loadingService.complete();
        this.isSending = false;

        this.alertService.swal({
          title: 'Success!',
          text: 'Thanks you for your feedback',
          type: 'success'
        });
      },
      error => {
        this.error = error;
      }
    )
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+web/modules/+contact-us/contact-us.component.ts